import { httpClient } from '@/shared/utils/http-client'

import type { ISFPUploadResponse } from '../types'

const ISFP_API_BASE_URL = import.meta.env.DEV
  ? `/isfp-extractor-v2/api/v1/isfp`
  : 'https://isfp-extractor-v2.enter.de/api/v1/isfp'

class ISFPUploadApi {
  /**
   * Upload an ISFP PDF file for a specific building
   * @param file - The PDF file to upload
   * @param buildingUuid - The UUID of the building
   * @returns Upload response with document ID and status
   */
  async uploadISFPFile(file: File, buildingUuid: string): Promise<ISFPUploadResponse> {
    const url = `${ISFP_API_BASE_URL}/upload/${buildingUuid}`
    return await httpClient.uploadFile<ISFPUploadResponse>(url, file)
  }

  /**
   * Upload an ISFP PDF file with progress tracking
   * @param file - The PDF file to upload
   * @param buildingUuid - The UUID of the building
   * @param onProgress - Callback for upload progress (0-100)
   * @returns Object containing upload promise and abort function
   */
  uploadISFPFileWithProgress(
    file: File,
    buildingUuid: string,
    onProgress?: (progress: number) => void
  ): { promise: Promise<ISFPUploadResponse>; abort: () => void } {
    const url = `${ISFP_API_BASE_URL}/upload/${buildingUuid}`
    return httpClient.uploadFileWithProgress<ISFPUploadResponse>(url, file, undefined, onProgress)
  }
}

export const isfpUploadApi = new ISFPUploadApi()
